"use client"

import {
  useState 
} from "react"

export const useHasCustomizationsDialog = () => {
  const [isCustomizationsDialogOpen, setIsCustomizationsDialogOpen] = useState(false)

  return {
    isCustomizationsDialogOpen,
    setIsCustomizationsDialogOpen
  }
}
